/* RESPONSIBLE TEAM: team-inbox-management */
import { ParentAction } from './action';

// eslint-disable-next-line ember/no-test-import-export
export default class CreateTaskTicket extends ParentAction {
  id = 'create-task-ticket';
  icon = 'back-office' as const;
  paneComponent = 'inbox2/command-k/create-linked-ticket/pane';
}
